import type { CSSProperties, ReactElement } from 'react';

import { cn } from '@/components/ui/cn';

import type { CategorySegment, UiFilters } from '../use-url-filters';

const SEGMENTS: { value: CategorySegment; label: string }[] = [
  { value: 'todos', label: 'Todos' },
  { value: 'flujo', label: 'Flujo documental' },
  { value: 'firmas', label: 'Firmas' },
  { value: 'edicion', label: 'Edición en línea' },
  { value: 'accesos', label: 'Roles y accesos' },
  { value: 'sesion', label: 'Sesión' },
];

interface Props {
  filters: UiFilters;
  onSegment: (s: CategorySegment) => void;
  onRange: (from: string, to: string) => void;
  className?: string;
  style?: CSSProperties;
}

/** Filtros de la bitácora: categoría (chips) + rango de fechas. Todo el estado
 *  vive en la URL (deep-link); los controles son solo su reflejo. */
export function TraceFilterBar({
  filters,
  onSegment,
  onRange,
  className,
  style,
}: Props): ReactElement {
  return (
    <div className={cn('filters', className)} style={style}>
      <div className="seg" role="group" aria-label="Filtrar por tipo de evento">
        {SEGMENTS.map((s) => (
          <button
            key={s.value}
            type="button"
            className={cn(filters.segment === s.value && 'on')}
            aria-pressed={filters.segment === s.value}
            onClick={() => onSegment(s.value)}
          >
            {s.label}
          </button>
        ))}
      </div>

      <div className="daterange" role="group" aria-label="Rango de fechas">
        <label className="fld">
          <span>Desde</span>
          <input
            type="date"
            value={filters.from}
            max={filters.to || undefined}
            onChange={(e) => onRange(e.target.value, filters.to)}
          />
        </label>
        <label className="fld">
          <span>Hasta</span>
          <input
            type="date"
            value={filters.to}
            min={filters.from || undefined}
            onChange={(e) => onRange(filters.from, e.target.value)}
          />
        </label>
        {(filters.from || filters.to) && (
          <button
            type="button"
            className="btn mut sm"
            onClick={() => onRange('', '')}
            aria-label="Quitar el filtro de fechas"
          >
            Limpiar fechas
          </button>
        )}
      </div>
    </div>
  );
}
